var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.id
    ? _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _vm.loading
            ? _c("div", { staticClass: "text-center" }, [
                _vm._v("\n      Loading...\n    ")
              ])
            : _vm.title
            ? _c("div", [
                _c("h2", [_vm._v(_vm._s(_vm.title))]),
                _vm._v(" "),
                _c("div", { staticClass: "row mb-4" }, [
                  _c("div", { staticClass: "col-auto" }, [
                    _vm.session_type === "individueel"
                      ? _c("span", [
                          _c("i", {
                            staticClass: "fa fa-user text-primary mr-1",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v("\n            Open inschrijving")
                        ])
                      : _vm.session_type === "groepssessie"
                      ? _c("span", [
                          _c("i", {
                            staticClass: "fa fa-users text-primary mr-1",
                            attrs: { "aria-hidden": "true" }
                          }),
                          _vm._v(" Teamtraining")
                        ])
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c("h3", { staticClass: "mb-0" }, [_vm._v("Gegevens boeker")]),
                _vm._v(" "),
                _c("div", { staticClass: "boeking__row" }, [
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Naam")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.booking_first_name) +
                          " " +
                          _vm._s(_vm.booking_last_name)
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Email")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.booking_email))])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "boeking__row" }, [
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Telefoonnummer")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.booking_phone))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Soort training")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(
                        _vm._s(
                          _vm.session_type === "individueel"
                            ? "Individuele training"
                            : "Teamtraining"
                        )
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "boeking__row" }, [
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Datum")]),
                    _vm._v(" "),
                    _c("span", [_vm._v(_vm._s(_vm.date))])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "boeking__value" }, [
                    _c("span", [_vm._v("Tijdstip")]),
                    _vm._v(" "),
                    _c("span", [
                      _vm._v(_vm._s(_vm.start) + " - " + _vm._s(_vm.end))
                    ])
                  ])
                ]),
                _vm._v(" "),
                !_vm.cancelled && _vm.hasEventPassed()
                  ? _c("div", { staticClass: "boeking__row" }, [
                      _c("div", { staticClass: "boeking__value" }, [
                        _c("span", [_vm._v("Review link")]),
                        _vm._v(" "),
                        _c("span", [_vm._v(_vm._s(_vm.review_link))])
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_definitive
                  ? _c("div", { staticClass: "boeking__notice" }, [
                      _vm._v(
                        "\n        Past deze boeking niet in jouw agenda, neem dan zsm contact met ons op via\n        "
                      ),
                      _c("a", { attrs: { href: "tel:038 853 9300" } }, [
                        _vm._v("038 853 9300")
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                !_vm.is_definitive && !_vm.cancelled
                  ? _c(
                      "div",
                      {
                        staticClass: "boeking__accept__button",
                        on: { click: _vm.handleAccept }
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "25",
                              height: "25",
                              viewBox: "0 0 25 25",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            _c("path", {
                              attrs: {
                                d:
                                  "M4.77985 13.4698C4.63767 13.3374 4.44963 13.2652 4.25532 13.2687C4.06102 13.2721 3.87564 13.3508 3.73822 13.4882C3.60081 13.6256 3.5221 13.811 3.51867 14.0053C3.51524 14.1996 3.58737 14.3877 3.71985 14.5298L8.21985 19.0298C8.36047 19.1703 8.5511 19.2492 8.74985 19.2492C8.9486 19.2492 9.13922 19.1703 9.27985 19.0298L20.2798 8.02985C20.4123 7.88767 20.4844 7.69963 20.481 7.50532C20.4776 7.31102 20.3989 7.12564 20.2615 6.98822C20.1241 6.85081 19.9387 6.7721 19.7444 6.76867C19.5501 6.76524 19.362 6.83737 19.2198 6.96985L8.74985 17.4398L4.77985 13.4698Z",
                                fill: "white"
                              }
                            })
                          ]
                        ),
                        _vm._v(" "),
                        _c("span", [_vm._v("Boeking accepteren")])
                      ]
                    )
                  : _vm._e()
              ])
            : _c("div", [
                _vm._v(
                  "\n      Het lukt niet om de boeking op te halen, controleer of hij bestaat of probeer het later opnieuw.\n    "
                )
              ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib/loaders/templateLoader.js?{}!/home/dev/tafelgasten.outlawz.dev/web/app/themes/expert/node_modules/vue-loader/lib?{}!./scripts/vue/Boekingen/Boeking.vue?vue&type=template&id=7be58454&scoped=true&
// module id = 441
// module chunks = 0